import { render } from "./ProjectDonationDetail.vue?vue&type=template&id=50dad1ca"
import script from "./ProjectDonationDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDonationDetail.vue?vue&type=script&lang=js"
script.render = render

export default script